module.exports = "/shifts/index-ebd5af.html";